// extracted by mini-css-extract-plugin
export default {"head__container":"styles_head__container__b0OHC","title__text":"styles_title__text__0mCxZ"};